// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__jS8Lq","rootSuccess":"CompleteLink_rootSuccess__jzD2R","rootFailure":"CompleteLink_rootFailure__1hRVS","isDisabled":"CompleteLink_isDisabled__3G3iK"};